<template>
    <LayoutSub>
        <SubSection>
            <div class="seminar_container">
                <div class="left_area">
                    <div class="photo_area">
                        <img :src="`${curriculumInfo?.filePath || null}`" alt="" @error="setDefaultImage" />
                    </div>
                    <div class="text_area">
                        <h2>{{ curriculumInfo?.subject || '' }}</h2>
                        <p>
                            <template v-for="(c, idx) in reContents" :key="idx"> {{ c }} <br /> </template>
                        </p>
                    </div>
                </div>
                <div class="right_area">
                    <table class="calendar_tbl">
                        <thead>
                            <tr>
                                <th colspan="7">
                                    <div class="current_day">
                                        <button class="current_btn white_btn" @click="goToToday">
                                            <img src="@/assets/before_arrow.png" alt="" />오늘
                                        </button>
                                        <button type="button" class="prev" @click="prevMonth">
                                            <img src="@/assets/left.png" alt="" />
                                        </button>
                                        <h2>{{ currentYear }}년 {{ currentMonth + 1 }}월</h2>
                                        <button type="button" class="next" @click="nextMonth">
                                            <img src="@/assets/right.png" alt="" />
                                        </button>
                                    </div>
                                </th>
                            </tr>
                            <tr class="d-f">
                                <th class="weekday" v-for="day in weekdays" :key="day">{{ day }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(week, index) in calendar" :key="index">
                                <td
                                    v-for="(day, idx) in week"
                                    :key="idx"
                                    :class="{
                                        past_day: day.isPast,
                                        curr_day: !day.isPast,
                                        selected_day:
                                            `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day.date).padStart(2, '0')}` ===
                                                selectedDateInfor && !day.isPast,
                                    }"
                                    @click="
                                        () => {
                                            if (!day.isPast) {
                                                selectDate(
                                                    day,
                                                    `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day.date).padStart(2, '0')}`
                                                );
                                            }
                                        }
                                    "
                                >
                                    {{ day.date }}
                                    <p v-if="day.schedule" class="schedule">{{ day.schedule }}건</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="schedule_info" v-if="selectedDate !== ''">
                        <p class="title" v-if="this.selectedDateCount > 0">
                            {{ todayDate }} 총 <span class="count">{{ this.selectedDateCount }}건</span>의 세미나 일정이 있습니다.
                        </p>
                        <div class="none_seminar_box" v-else>
                            <p class="title">등록된 세미나가 없습니다.</p>
                        </div>
                        <div class="accordion" v-if="this.selectedDateCount > 0">
                            <div v-for="(item, index) in accordionItems" :key="index" class="accordion-item" ref="accordionRefs">
                                <div class="accordion-header" @click="() => toggleAccordion(index)">
                                    <p>{{ item.subject.length > 36 ? item.subject.substring(0, 36) + '...' : item.subject }}</p>
                                    <span class="status" :class="{ accepting: item.status === 'Y', closed: item.status === 'N' }">{{
                                        item.status === 'Y' ? '접수중' : '마감'
                                    }}</span>
                                    <button style="margin-left: auto">
                                        <img
                                            src="@/assets/history_dropdown.png"
                                            alt=""
                                            :style="activeIndex === index ? 'transform: rotate(180deg)' : ''"
                                        />
                                    </button>
                                </div>
                                <div class="accordion-content" :class="{ active: activeIndex === index }" ref="accordionContent">
                                    <div class="info_wrap">
                                        <p>- 주관부서 : {{ item.department }}</p>
                                        <p>- 게시일자 : {{ item.postDate }}</p>
                                        <p>- 날짜 : {{ foramtDate(item.startDate, item.endDate) }}</p>
                                        <p>- 장소 : {{ item.place }}</p>
                                        <p>- 주소: {{ item.addr }}</p>
                                        <p>- 정원 : {{ item.applicantCnt }}</p>
                                        <p>- 참고사항 : {{ item.notes }}</p>
                                        <div class="btn_wrap">
                                            <button type="button" class="edit_btn" @click="() => editModalOpen(item)">수정</button>
                                            <button
                                                v-if="+item.applicantCnt.split('/')[0] < +item.applicantCnt.split('/')[1]"
                                                type="button"
                                                class="apply_btn"
                                                @click="
                                                    () => {
                                                        const [curr, max] = item.applicantCnt.split('/');
                                                        if (+curr >= +max) return;
                                                        modalOpen(item);
                                                    }
                                                "
                                            >
                                                신청하기
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SubSection>
    </LayoutSub>

    <!-- 세미나 신청 모달 -->
    <div class="modal_container seminar" v-if="modalCheck" @click.stop>
        <div class="modal_wrapper modal" @click.stop>
            <div class="modal_header">
                <p>{{ selectedSeminar.subject.length > 48 ? selectedSeminar.subject.substring(0, 48) + '...' : selectedSeminar.subject }}</p>
                <button class="modal_close" @click="modalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <div class="modal_content">
                    <div class="content_body">
                        <section>
                            <div class="notification">
                                <p>
                                    <template v-for="(c, idx) in reContents2" :key="idx"> {{ c }} <br /> </template>
                                </p>
                            </div>
                        </section>
                        <section>
                            <p class="section_title">신청 정보</p>
                            <ul class="list">
                                <li class="item">
                                    <div class="input_group require">
                                        <span class="title">대리점 코드</span>
                                        <input type="text" ref="bussno" />
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="input_group require">
                                        <!-- 숫자만 입력가능하며 최대 4자리 입력 가능 -->
                                        <span class="title">비밀번호</span>
                                        <input type="password" ref="password" />
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="input_group require">
                                        <span class="title">이메일</span>
                                        <div class="input_row">
                                            <input type="text" class="w-135" ref="email1" />
                                            <span>@</span>
                                            <!-- [D] 직접 입력시에만 활성화 -->
                                            <input type="text" class="w-190" ref="email2" :disabled="!emailEditable" />
                                            <select ref="emailSelect" @change="handleSelectChange">
                                                <option value="">직접입력</option>
                                                <option value="kicc.kr">kicc.kr</option>
                                                <option value="naver.com">naver.com</option>
                                                <option value="daum.net">daum.net</option>
                                                <option value="gmail.com">gmail.com</option>
                                            </select>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div v-for="(attendee, index) in attendees" :key="index">
                                <ul class="list" :id="`attendee_${index}`">
                                    <li class="item">
                                        <div class="item_row require">
                                            <span class="title">참석자 정보({{ index + 1 }})</span>
                                            <div class="right_area">
                                                <span class="info" v-if="index === 0">신청 가능 인원 {{ selectedSeminar.availableCnt }}명</span>
                                                <div class="btn_wrap">
                                                    <button
                                                        v-if="attendees.length < selectedSeminar.availableCnt && index === 0"
                                                        @click="addAttendee"
                                                        class="white_btn"
                                                        type="button"
                                                    >
                                                        인원 추가
                                                    </button>
                                                    <button v-if="index !== 0" @click="() => removeAttendee(index)" class="black_btn" type="button">
                                                        삭제
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="item_row">
                                            <div class="input_group require">
                                                <span class="title">이름</span>
                                                <input type="text" class="user_info_input" v-model="attendee.name" name="name" />
                                            </div>
                                            <div class="input_group require">
                                                <span class="title">직급</span>
                                                <input type="text" class="user_info_input" v-model="attendee.position" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group require">
                                            <span class="title">휴대폰 번호</span>
                                            <div class="input_row">
                                                <select class="w-134" v-model="attendee.phone">
                                                    <option value="">선택</option>
                                                    <option value="010">010</option>
                                                    <option value="011">011</option>
                                                    <option value="016">016</option>
                                                    <option value="017">017</option>
                                                    <option value="018">018</option>
                                                    <option value="019">019</option>
                                                </select>
                                                <span>-</span>
                                                <!-- 숫자만 입력 가능 -->
                                                <input type="text" class="w-134" v-model="attendee.phoneNumber1" maxlength="4" />
                                                <span>-</span>
                                                <input type="text" class="w-134" v-model="attendee.phoneNumber2" maxlength="4" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group">
                                            <span class="title">주차여부</span>
                                            <div class="radio_group">
                                                <label :for="'parking_' + index + '_yes'">
                                                    <input type="radio" :id="'parking_' + index + '_yes'" v-model="attendee.parking" value="Y" />
                                                    <span class="radio_box"></span>
                                                    <span>예</span>
                                                </label>
                                                <label :for="'parking_' + index + '_no'">
                                                    <input type="radio" :id="'parking_' + index + '_no'" v-model="attendee.parking" value="N" />
                                                    <span class="radio_box"></span>
                                                    <span>아니요</span>
                                                </label>
                                                <label :for="'parking_' + index + '_none'">
                                                    <input type="radio" :id="'parking_' + index + '_none'" v-model="attendee.parking" value="X" />
                                                    <span class="radio_box"></span>
                                                    <span>해당없음</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group">
                                            <span class="title">차량번호</span>
                                            <input
                                                type="text"
                                                v-model="attendee.carNumber"
                                                placeholder="장소에 따라 주차 지원이 어려울 수 있습니다."
                                            />
                                            <span>ex) 000가 0000</span>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group">
                                            <span class="title"
                                                >숙박시설<br />
                                                이용 여부</span
                                            >
                                            <div class="radio_group">
                                                <label :for="'accommodation_' + index + '_yes'">
                                                    <input
                                                        type="radio"
                                                        :id="'accommodation_' + index + '_yes'"
                                                        v-model="attendee.accommodation"
                                                        value="Y"
                                                    />
                                                    <span class="radio_box"></span>
                                                    <span>예</span>
                                                </label>
                                                <label :for="'accommodation_' + index + '_no'">
                                                    <input
                                                        type="radio"
                                                        :id="'accommodation_' + index + '_no'"
                                                        v-model="attendee.accommodation"
                                                        value="N"
                                                    />
                                                    <span class="radio_box"></span>
                                                    <span>아니요</span>
                                                </label>
                                                <label :for="'accommodation_' + index + '_none'">
                                                    <input
                                                        type="radio"
                                                        :id="'accommodation_' + index + '_none'"
                                                        v-model="attendee.accommodation"
                                                        value="X"
                                                    />
                                                    <span class="radio_box"></span>
                                                    <span>해당없음</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <template v-if="selectedSeminar.orgFilename || selectedSeminar.filePath">
                                        <li class="item">
                                            <div :class="selectedSeminar.fileRequiredYn === 'Y' ? 'input_group require' : 'input_group'">
                                                <span class="title">상계처리 동의서<br />및 동의 안내</span>
                                                <div class="col">
                                                    <a
                                                        class="download_btn white_btn"
                                                        :download="selectedSeminar.orgFilename"
                                                        :href="selectedSeminar.filePath"
                                                        >상계처리 동의서 다운로드</a
                                                    >
                                                    <div class="input_row">
                                                        <span class="check_info">상계처리서를 자세히 읽어 보신 후 동의한다면 체크 바랍니다.</span>
                                                        <label :for="'check_agr_' + index" class="checkbox_label">
                                                            <input type="checkbox" v-model="attendee.agreement" :id="'check_agr_' + index" />
                                                            <span class="check_box"></span>
                                                            <span>예</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </template>
                                    <template v-if="selectedSeminar.fileRequiredYn === 'Y'">
                                        <!-- <li class="item">
                                            <div class="input_group require">
                                                <span class="title">상계처리 동의</span>
                                                <div class="radio_group">
                                                    <label :for="'consent_' + index + '_yes'">
                                                        <input type="radio" :id="'consent_' + index + '_yes'" v-model="attendee.consent" value="Y" />
                                                        <span class="radio_box"></span>
                                                        <span>예</span>
                                                    </label>
                                                    <label :for="'consent_' + index + '_no'">
                                                        <input type="radio" :id="'consent_' + index + '_no'" v-model="attendee.consent" value="N" />
                                                        <span class="radio_box"></span>
                                                        <span>아니요</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </li> -->
                                    </template>
                                </ul>
                            </div>
                            <ul class="list">
                                <li class="item">
                                    <div class="input_group">
                                        <span class="title">기타 요청사항</span>
                                        <input type="text" style="width: 100%" ref="etcRequest" />
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="input_group col">
                                        <span class="title">개인정보 수집 및 이용 동의</span>
                                        <div class="textarea_box">
                                            <p>세미나 신청 및 참석을 위해 최소한의 개인정보 활용 동의가 필요합니다.</p>
                                            <br />
                                            <p>○ 수집항목(필수)</p>
                                            <p>- 대리점코드, 이메일주소, 참석자 이름, 참석자 직급, 휴대폰번호, (선택) 주차여부, 차량번호, 숙박여부</p>
                                            <br />
                                            <p>○ 목적</p>
                                            <p>
                                                - 세미나 신청 및 참석 여부에 대한 회신, 숙박시설에 대한 숙박자 명단 제공,<br />
                                                상계처리에 따른 대리점 및 참석자 정보 조회시 사용
                                            </p>
                                            <br />
                                            <p>○ 보유기간</p>
                                            <p>- 신청일로부터 1년</p>
                                        </div>
                                        <div class="input_row">
                                            <span class="check_info">개인정보 수집 및 이용동의를 자세히 읽어 보신 후 동의해 주시기 바랍니다.</span>
                                            <label for="check_agr3" class="checkbox_label">
                                                <input type="checkbox" name="" id="check_agr3" ref="agreeChk" />
                                                <span class="check_box"></span>
                                                <span>동의</span>
                                            </label>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </section>
                        <section class="button_wrap">
                            <!-- [D] 필수값 미입력/미체크 후 버튼 클릭 시 alert 안내 -->
                            <button type="button" class="black_btn" @click="submit">신청하기</button>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 세미나 신청 수정 모달 -->
    <div class="modal_container seminar" v-if="modalCheck2" @click.stop>
        <div class="modal_wrapper modal" @click.stop>
            <div class="modal_header">
                <p>세미나 신청 수정</p>
                <button class="modal_close" @click="editModalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body">
                <div class="modal_content">
                    <div class="content_body">
                        <section>
                            <p class="section_title">신청 정보</p>
                            <ul class="list">
                                <li class="item">
                                    <div class="input_group require">
                                        <span class="title">대리점 코드</span>
                                        <input type="text" ref="bussno_edit" />
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="input_group require">
                                        <span class="title">비밀번호</span>
                                        <input type="password" ref="password_edit" />
                                    </div>
                                </li>
                            </ul>
                        </section>
                        <section class="button_wrap">
                            <button type="button" class="white_btn" @click="editModalOpen">취소</button>
                            <button type="button" class="black_btn" @click="editSubmit">조회</button>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 세미나 신청 수정 내용 모달 -->
    <div class="modal_container seminar" v-if="modalCheck3" @click.stop>
        <div class="modal_wrapper modal" @click.stop>
            <div class="modal_header">
                <p>{{ editResult.seminar.subject }}</p>
                <button class="modal_close" @click="editDetailModalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <div class="modal_content">
                    <div class="content_body">
                        <section>
                            <div class="notification">
                                <p>
                                    <template v-for="(c, idx) in reContents2" :key="idx"> {{ c }} <br /> </template>
                                </p>
                            </div>
                        </section>
                        <section>
                            <p class="section_title">신청 정보</p>
                            <ul class="list">
                                <li class="item">
                                    <div class="input_group require">
                                        <span class="title">대리점 코드</span>
                                        <input type="text" :value="editResult.result.bussno" readonly />
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="input_group require">
                                        <!-- 숫자만 입력가능하며 최대 4자리 입력 가능 -->
                                        <span class="title">비밀번호</span>
                                        <input type="password" />
                                        <span class="err_msg">* 비밀번호를 변경할 경우에만 입력하세요</span>
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="input_group require">
                                        <span class="title">이메일</span>
                                        <div class="input_row">
                                            <input type="text" :value="editResult.result.email.split('@')[0]" class="w-135" ref="edit_email1" />
                                            <span>@</span>
                                            <input type="text" :value="editResult.result.email.split('@')[1]" class="w-135" ref="edit_email2" />
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <div v-for="(attendee, index) in attendees" :key="index">
                                <ul class="list" :id="`attendee_${index}`">
                                    <li class="item">
                                        <div class="item_row require">
                                            <span class="title">참석자 정보({{ index + 1 }})</span>
                                            <div class="right_area">
                                                <span class="info" v-if="index === 0">신청 가능 인원 {{ selectedSeminar.availableCnt }}명</span>
                                                <div class="btn_wrap">
                                                    <button
                                                        v-if="attendees.length < selectedSeminar.availableCnt && index === 0"
                                                        @click="addAttendee"
                                                        class="white_btn"
                                                        type="button"
                                                    >
                                                        인원 추가
                                                    </button>
                                                    <button v-if="index !== 0" @click="() => removeAttendee(index)" class="black_btn" type="button">
                                                        삭제
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="item_row">
                                            <div class="input_group require">
                                                <span class="title">이름</span>
                                                <input type="text" class="user_info_input" v-model="attendee.name" name="name" />
                                            </div>
                                            <div class="input_group require">
                                                <span class="title">직급</span>
                                                <input type="text" class="user_info_input" v-model="attendee.position" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group require">
                                            <span class="title">휴대폰 번호</span>
                                            <div class="input_row">
                                                <select class="w-134" v-model="attendee.phone">
                                                    <option value="">선택</option>
                                                    <option value="010">010</option>
                                                    <option value="011">011</option>
                                                    <option value="016">016</option>
                                                    <option value="017">017</option>
                                                    <option value="018">018</option>
                                                    <option value="019">019</option>
                                                </select>
                                                <span>-</span>
                                                <!-- 숫자만 입력 가능 -->
                                                <input type="text" class="w-134" v-model="attendee.phoneNumber1" />
                                                <span>-</span>
                                                <input type="text" class="w-134" v-model="attendee.phoneNumber2" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group">
                                            <span class="title">주차여부</span>
                                            <div class="radio_group">
                                                <label :for="'parking_' + index + '_yes'">
                                                    <input type="radio" :id="'parking_' + index + '_yes'" v-model="attendee.parking" value="Y" />
                                                    <span class="radio_box"></span>
                                                    <span>예</span>
                                                </label>
                                                <label :for="'parking_' + index + '_no'">
                                                    <input type="radio" :id="'parking_' + index + '_no'" v-model="attendee.parking" value="N" />
                                                    <span class="radio_box"></span>
                                                    <span>아니요</span>
                                                </label>
                                                <label :for="'parking_' + index + '_none'">
                                                    <input type="radio" :id="'parking_' + index + '_none'" v-model="attendee.parking" value="X" />
                                                    <span class="radio_box"></span>
                                                    <span>해당없음</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group">
                                            <span class="title">차량번호</span>
                                            <input
                                                type="text"
                                                v-model="attendee.carNumber"
                                                placeholder="장소에 따라 주차 지원이 어려울 수 있습니다."
                                            />
                                            <span>ex) 000가 0000</span>
                                        </div>
                                    </li>
                                    <li class="item">
                                        <div class="input_group">
                                            <span class="title"
                                                >숙박시설<br />
                                                이용 여부</span
                                            >
                                            <div class="radio_group">
                                                <label :for="'accommodation_' + index + '_yes'">
                                                    <input
                                                        type="radio"
                                                        :id="'accommodation_' + index + '_yes'"
                                                        v-model="attendee.accommodation"
                                                        value="Y"
                                                    />
                                                    <span class="radio_box"></span>
                                                    <span>예</span>
                                                </label>
                                                <label :for="'accommodation_' + index + '_no'">
                                                    <input
                                                        type="radio"
                                                        :id="'accommodation_' + index + '_no'"
                                                        v-model="attendee.accommodation"
                                                        value="N"
                                                    />
                                                    <span class="radio_box"></span>
                                                    <span>아니요</span>
                                                </label>
                                                <label :for="'accommodation_' + index + '_none'">
                                                    <input
                                                        type="radio"
                                                        :id="'accommodation_' + index + '_none'"
                                                        v-model="attendee.accommodation"
                                                        value="X"
                                                    />
                                                    <span class="radio_box"></span>
                                                    <span>해당없음</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <template v-if="selectedSeminar.fileRequiredYn === 'Y'">
                                        <li class="item">
                                            <div class="input_group">
                                                <span class="title">상계처리 동의</span>
                                                <div class="radio_group">
                                                    <label :for="'consent_' + index + '_yes'">
                                                        <input type="radio" :id="'consent_' + index + '_yes'" v-model="attendee.consent" value="Y" />
                                                        <span class="radio_box"></span>
                                                        <span>예</span>
                                                    </label>
                                                    <label :for="'consent_' + index + '_no'">
                                                        <input type="radio" :id="'consent_' + index + '_no'" v-model="attendee.consent" value="N" />
                                                        <span class="radio_box"></span>
                                                        <span>아니요</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="item">
                                            <div class="input_group">
                                                <span class="title">상계처리 동의서<br />및 동의 안내</span>
                                                <div class="col">
                                                    <a
                                                        class="download_btn white_btn"
                                                        :download="selectedSeminar.orgFilename"
                                                        :href="selectedSeminar.filePath"
                                                        >상계처리 동의서 다운로드</a
                                                    >
                                                    <div class="input_row">
                                                        <span class="check_info">상계처리서를 자세히 읽어 보신 후 동의한다면 체크 바랍니다.</span>
                                                        <label :for="'check_agr_' + index" class="checkbox_label">
                                                            <input type="checkbox" v-model="attendee.agreement" :id="'check_agr_' + index" />
                                                            <span class="check_box"></span>
                                                            <span>예</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>

                            <ul class="list">
                                <li class="item">
                                    <div class="input_group">
                                        <span class="title">기타 요청사항</span>
                                        <input type="text" style="width: 100%" :value="editResult.result.etcRequest" ref="edit_etcRequest" />
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="input_group col">
                                        <span class="title">개인정보 수집 및 이용 동의</span>
                                        <div class="textarea_box">
                                            <p>세미나 신청 및 참석을 위해 최소한의 개인정보 활용 동의가 필요합니다.</p>
                                            <br />
                                            <p>○ 수집항목(필수)</p>
                                            <p>- 대리점코드, 이메일주소, 참석자 이름, 참석자 직급, 휴대폰번호, (선택) 주차여부, 차량번호, 숙박여부</p>
                                            <br />
                                            <p>○ 목적</p>
                                            <p>
                                                - 세미나 신청 및 참석 여부에 대한 회신, 숙박시설에 대한 숙박자 명단 제공,<br />
                                                상계처리에 따른 대리점 및 참석자 정보 조회시 사용
                                            </p>
                                            <br />
                                            <p>○ 보유기간</p>
                                            <p>- 신청일로부터 1년</p>
                                        </div>
                                        <div class="input_row">
                                            <span class="check_info">개인정보 수집 및 이용동의를 자세히 읽어 보신 후 동의해 주시기 바랍니다.</span>
                                            <label for="check_agr6" class="checkbox_label">
                                                <input type="checkbox" name="" id="check_agr6" ref="edit_agreeChk" />
                                                <span class="check_box"></span>
                                                <span>동의</span>
                                            </label>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </section>
                        <section class="button_wrap">
                            <!-- [D] 신청 취소 데이터를 관리자쪽에 보낸 후 세미나 메인 페이지로 이동 -->
                            <button type="button" class="black_btn" @click="cancleSeminar">신청취소</button>
                            <!-- [D] 변경 된 내용으로 수정 -->
                            <button type="button" class="orange_btn" @click="updateSubmit">수정</button>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import defaultImagePath from '@/assets/no_image.png';
import { getCurriculumInfo, getSeminarList, postSEminarDetail, postSeminarReq, postSeminarUpdate, seminarRequestCancel } from '@/api';

export default {
    components: {
        SubSection,
        LayoutSub,
    },
    data() {
        return {
            curriculumInfo: {
                contents: '',
            },
            selectedDayObj: {},
            activeIndex: null,
            selectedDate: '',
            selectedDateCount: 0,
            selectedSeminar: null,
            selectedDateInfor: '',
            emailEditable: true,
            accordionItems: [],
            contentHeights: [],
            editResult: {},
            defaultImagePath,
            modalCheck: false,
            modalCheck2: false,
            modalCheck3: false,
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            calendar: [],
            schedules: {},
            attendees: [
                {
                    name: '',
                    position: '',
                    phone: '010',
                    phoneNumber1: '',
                    phoneNumber2: '',
                    parking: 'Y',
                    carNumber: '',
                    accommodation: 'Y',
                    consent: null,
                    agreement: false,
                },
            ],
        };
    },
    watch: {
        async $route() {
            await this.getSeminarList();
        },
    },
    methods: {
        async getSeminarList() {
            try {
                const { list } = await getSeminarList(this.$route.query);
                this.schedules = {};
                this.data = list;
                list.forEach((el) => {
                    const date = new Date(el.startDate);
                    const schedulesDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
                        2,
                        '0'
                    )}`;
                    if (schedulesDate in this.schedules) {
                        this.schedules[schedulesDate] += 1;
                    } else {
                        this.schedules[schedulesDate] = 1;
                    }
                });
                this.generateCalendar();
            } catch (err) {
                this.data = [];
            }
        },
        setDefaultImage(event) {
            event.target.src = this.defaultImagePath; // 기본 이미지로 대체
        },
        toggleAccordion(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },
        modalOpen(item) {
            if (item?.applicantCnt) {
                this.selectedSeminar = item;
                this.attendees = [
                    {
                        name: '',
                        position: '',
                        phone: '010',
                        phoneNumber1: '',
                        phoneNumber2: '',
                        parking: 'Y',
                        carNumber: '',
                        accommodation: 'Y',
                        // consent: this.selectedSeminar.fileRequiredYn === 'Y' ? 'Y' : 'X',
                        consent: null,
                        agreement: this.selectedSeminar.agreement,
                    },
                ];
                const [current, max] = this.selectedSeminar.applicantCnt.split('/');
                this.selectedSeminar.availableCnt = +max - +current >= 0 ? +max - +current : 0;
            }
            this.modalCheck = !this.modalCheck;
            if (this.modalCheck) this.$lenis.stop();
            else this.$lenis.start();
        },
        editModalOpen(item) {
            if (item?.applicantCnt) {
                this.selectedSeminar = item;
                this.attendees = [
                    {
                        name: '',
                        position: '',
                        phone: '010',
                        phoneNumber1: '',
                        phoneNumber2: '',
                        parking: 'Y',
                        carNumber: '',
                        accommodation: 'Y',
                        // consent: this.selectedSeminar.fileRequiredYn === 'Y' ? 'Y' : 'X',
                        consent: null,
                        agreement: this.selectedSeminar.agreement
                    },
                ];
                const [current, max] = this.selectedSeminar.applicantCnt.split('/');
                this.selectedSeminar.availableCnt = +max - +current >= 0 ? +max - +current : 0;
            }

            this.modalCheck2 = !this.modalCheck2;
            if (this.modalCheck2) this.$lenis.stop();
            else this.$lenis.start();
        },
        editDetailModalOpen() {
            this.modalCheck2 = false;
            this.modalCheck3 = !this.modalCheck3;
            if (this.modalCheck3) this.$lenis.stop();
            else this.$lenis.start();
        },
        selectDate(day, dayString) {
            this.selectedDayObj = day;
            this.selectedDateInfor = dayString;
            this.accordionItems = this.data
                .filter((el) => el.startDate.includes(dayString))
                .sort((a, b) => {
                    if (a.array && b.array) return b.array - a.array;
                    else return -1;
                });

            if (!day.isPast) {
                this.selectedDate = `${this.currentYear}.${String(this.currentMonth + 1).padStart(2, '0')}.${String(day.date).padStart(2, '0')}`;
                this.selectedDateCount = day.schedule || 0;
            }
        },
        generateCalendar() {
            let firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
            let lastDate = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
            let prevLastDate = new Date(this.currentYear, this.currentMonth, 0).getDate();

            let days = [];
            for (let i = firstDay - 1; i >= 0; i--) {
                days.push({ date: prevLastDate - i, isPast: true });
            }
            for (let i = 1; i <= lastDate; i++) {
                let key = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
                days.push({ date: i, isPast: false, schedule: this.schedules[key] || null });
            }
            while (days.length % 7 !== 0) {
                days.push({ date: days.length - lastDate - firstDay + 1, isPast: true });
            }

            this.calendar = [];
            while (days.length) {
                this.calendar.push(days.splice(0, 7));
            }
        },
        prevMonth() {
            this.currentMonth--;
            if (this.currentMonth < 0) {
                this.currentMonth = 11;
                this.currentYear--;
            }
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    date: `${this.currentYear}${String(+this.currentMonth + 1).padStart(2, 0)}`,
                },
            });
            this.generateCalendar();
        },
        nextMonth() {
            this.currentMonth++;
            if (this.currentMonth > 11) {
                this.currentMonth = 0;
                this.currentYear++;
            }
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    date: `${this.currentYear}${String(+this.currentMonth + 1).padStart(2, 0)}`,
                },
            });
            this.generateCalendar();
        },
        goToToday() {
            const today = new Date();
            this.currentYear = today.getFullYear();
            this.currentMonth = today.getMonth();
            this.generateCalendar();
            this.selectedDate = `${this.currentYear}.${String(this.currentMonth + 1).padStart(2, '0')}.${String(today.getDate()).padStart(2, '0')}`;
            let key = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
            this.selectedDateCount = this.schedules[key] || 0;

            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    date: `${this.currentYear}${String(+this.currentMonth + 1).padStart(2, 0)}`,
                },
            });
            this.selectedDateInfor = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(today.getDate()).padStart(
                2,
                '0'
            )}`;
        },
        addAttendee() {
            if (this.attendees.length < this.selectedSeminar.availableCnt) {
                this.attendees.push({
                    name: '',
                    position: '',
                    phone: '010',
                    phoneNumber1: '',
                    phoneNumber2: '',
                    parking: 'Y',
                    carNumber: '',
                    accommodation: 'Y',
                    // consent: this.selectedSeminar.fileRequiredYn === 'Y' ? 'Y' : 'X',
                    consent: null,
                    agreement: false,
                });
            } else {
                alert('현재 참석자가 정원을 초과합니다.');
            }
        },
        removeAttendee(index) {
            if (this.attendees.length > 1) {
                this.attendees.splice(index, 1);
            }
        },
        handleSelectChange(e) {
            if (e.target.value === '') {
                this.emailEditable = true;
                this.$refs.email2.value = '';
            } else {
                this.emailEditable = false;
                this.$refs.email2.value = e.target.value;
            }
        },
        async submit() {
            if (this.$refs.bussno.value === '') {
                alert('대리점번호는 필수입니다.');
                this.$refs.bussno.focus();
                return;
            }

            if (this.$refs.password.value === '') {
                alert('비밀번호는 필수입니다.');
                this.$refs.password.focus();
                return;
            }

            if (this.$refs.email1.value === '') {
                alert('이메일은 필수입니다.');
                this.$refs.email1.focus();
                return;
            } else {
                if (!/^[a-zA-Z0-9._-]{1,64}$/.test(this.$refs.email1.value)) {
                    alert('이메일 주소를 확인해주세요.');
                    this.$refs.email1.focus();
                    return;
                }
            }

            if (this.$refs.email2.value === '') {
                alert('이메일은 필수입니다.');
                this.$refs.email2.focus();
                return;
            } else {
                if (!/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.$refs.email2.value)) {
                    alert('이메일 주소를 확인해주세요.');
                    this.$refs.email2.focus();
                    return;
                }
            }

            for (let item of this.attendees) {
                if (item.name === '') return alert(`참석자 이름을 입력해주세요.`);
                if (item.position === '') return alert(`참석자 직급을 입력해주세요.`);
                if (item.phone === '') return alert(`참석자 휴대폰번호를 입력해주세요.`);
                if (item.phoneNumber1 === '') return alert(`참석자 휴대폰번호를 입력해주세요.`);
                else if (!/^\d{3,4}$/.test(item.phoneNumber1)) return alert(`휴대폰번호를 확인해주세요.`);
                if (item.phoneNumber2 === '') return alert(`참석자 휴대폰번호를 입력해주세요.`);
                else if (!/^\d{4}$/.test(item.phoneNumber2)) return alert(`휴대폰번호를 확인해주세요.`);
                // if (this.selectedSeminar.fileRequiredYn === 'Y') {
                //     if (item.consent !== 'Y') return alert(`상계처리 동의를 해주세요.`);
                // }
                if (this.selectedSeminar.fileRequiredYn === 'Y' && !item.agreement) return alert(`상계처리 동의를 해주세요.`);
            }

            if (!this.$refs.agreeChk?.checked) {
                alert('개인정보 수집 및 이용 동의에 체크해주세요.');
                return;
            }

            const submitDate = {
                seminarIdx: this.selectedSeminar.idx,
                bussno: this.$refs.bussno.value,
                password: this.$refs.password.value,
                email: `${this.$refs.email1.value}@${this.$refs.email2.value}`,
                etcRequest: this.$refs.etcRequest.value,
                memberList: [],
            };
            this.attendees.map((el) => {
                const memberObj = {
                    name: el.name,
                    position: el.position,
                    hpNo: `${el.phone}${el.phoneNumber1}${el.phoneNumber2}`,
                    parkingYn: el.parking,
                    carnum: el.carNumber,
                    stayYn: el.accommodation,
                    agreeYn: el.consent,
                };
                submitDate.memberList.push(memberObj);
            });

            await postSeminarReq(submitDate);
            await this.getSeminarList();
            this.selectDate(this.selectedDayObj, this.selectedDateInfor);
            alert('신청이 접수되었습니다.');
            this.modalOpen();
        },
        async updateSubmit() {
            if (this.$refs.edit_email1.value === '') {
                alert('이메일은 필수입니다.');
                this.$refs.edit_email1.focus();
                return;
            } else {
                if (!/^[a-zA-Z0-9._-]{1,64}$/.test(this.$refs.edit_email1.value)) {
                    alert('이메일 주소를 확인해주세요.');
                    this.$refs.edit_email1.focus();
                    return;
                }
            }

            if (this.$refs.edit_email2.value === '') {
                alert('이메일은 필수입니다.');
                this.$refs.edit_email2.focus();
                return;
            } else {
                if (!/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.$refs.edit_email2.value)) {
                    alert('이메일 주소를 확인해주세요.');
                    this.$refs.edit_email2.focus();
                    return;
                }
            }

            for (let item of this.attendees) {
                if (item.name === '') return alert(`참석자 이름을 입력해주세요.`);
                if (item.position === '') return alert(`참석자 직급을 입력해주세요.`);
                if (item.phone === '') return alert(`참석자 휴대폰번호를 입력해주세요.`);
                if (item.phoneNumber1 === '') return alert(`참석자 휴대폰번호를 입력해주세요.`);
                else if (!/^\d{3,4}$/.test(item.phoneNumber1)) return alert(`휴대폰번호를 확인해주세요.`);
                if (item.phoneNumber2 === '') return alert(`참석자 휴대폰번호를 입력해주세요.`);
                else if (!/^\d{4}$/.test(item.phoneNumber2)) return alert(`휴대폰번호를 확인해주세요.`);
                // if (this.selectedSeminar.fileRequiredYn === 'Y') {
                //     if (item.consent !== 'Y') return alert(`상계처리 동의를 해주세요.`);
                // }
                if (this.selectedSeminar.fileRequiredYn === 'Y' && !item.agreement) return alert(`상계처리 동의를 해주세요.`);
            }

            if (!this.$refs.edit_agreeChk?.checked) {
                alert('개인정보 수집 및 이용 동의에 체크해주세요.');
                return;
            }

            const submitDate = {
                seminarIdx: this.selectedSeminar.idx,
                bussno: this.tempBussno,
                password: this.tempPwd,
                email: `${this.$refs.edit_email1.value}@${this.$refs.edit_email2.value}`,
                etcRequest: this.$refs.edit_etcRequest.value,
                memberList: [],
            };
            this.attendees.map((el) => {
                const memberObj = {
                    name: el.name,
                    position: el.position,
                    hpNo: `${el.phone}${el.phoneNumber1}${el.phoneNumber2}`,
                    parkingYn: el.parking,
                    carnum: el.carNumber,
                    stayYn: el.accommodation,
                    // agreeYn: el.consent,
                };
                submitDate.memberList.push(memberObj);
            });
            await postSeminarUpdate(submitDate);
            await this.getSeminarList();
            this.selectDate(this.selectedDayObj, this.selectedDateInfor);
            alert('수정이 완료되었습니다.');
            this.editDetailModalOpen();
        },
        async editSubmit() {
            const result = await postSEminarDetail({
                seminarIdx: this.selectedSeminar.idx,
                bussno: this.$refs.bussno_edit.value,
                password: this.$refs.password_edit.value,
            });

            this.tempBussno = this.$refs.bussno_edit.value;
            this.tempPwd = this.$refs.password_edit.value;

            this.editResult = result.data;

            if ('result' in this.editResult) {
                this.attendees = this.editResult.result.memberList.map((el) => {
                    return {
                        name: el.name,
                        position: el.position,
                        phone: el.hpNo.slice(0, 3),
                        phoneNumber1: el.hpNo.slice(3, 7),
                        phoneNumber2: el.hpNo.slice(7),
                        parking: el.parkingYn,
                        carNumber: el.carnum,
                        accommodation: el.stayYn,
                        // consent: el.agreeYn,
                        consent: null,
                        agreement: true,
                    };
                });
                this.editDetailModalOpen();
            } else {
                alert('신청정보가 존재하지 않습니다.');
            }
        },
        async cancleSeminar() {
            const result = await seminarRequestCancel({
                seminarIdx: this.selectedSeminar.idx,
                bussno: this.tempBussno,
            });
            if (result.data.status === 'success') {
                alert('신청이 취소되었습니다.');
                await this.getSeminarList();
                this.selectDate(this.selectedDayObj, this.selectedDateInfor);
                this.editDetailModalOpen();
            } else {
                alert(result.data.message);
            }
        },
        foramtDate(start, end) {
            const startDate = new Date(start);
            const endDate = new Date(end);

            const startYear = String(startDate.getFullYear()),
                startMonth = String(startDate.getMonth() + 1).padStart(2, 0),
                startDay = String(startDate.getDate()).padStart(2, 0),
                startHour = String(startDate.getHours()).padStart(2, 0),
                startMinite = String(startDate.getMinutes()).padStart(2, 0);

            const endYear = String(endDate.getFullYear()),
                endMonth = String(endDate.getMonth() + 1).padStart(2, 0),
                endDay = String(endDate.getDate()).padStart(2, 0),
                endHour = String(endDate.getHours()).padStart(2, 0),
                endMinite = String(endDate.getMinutes()).padStart(2, 0);

            const startDateFirst = `${startYear}.${startMonth}.${startDay}`;
            const startDateSecond = `${startHour}:${startMinite}`;

            const endDateFirst = `${endYear}.${endMonth}.${endDay}`;
            const endDateSecond = `${endHour}:${endMinite}`;

            if (startDateFirst === endDateFirst) return `${startDateFirst} ${startDateSecond}~${endDateSecond}`;
            else return `${startDateFirst} ${startDateSecond} ~ ${endDateFirst} ${endDateSecond}`;
        },
    },
    async mounted() {
        this.$lenis.start();
        this.getSeminarList();

        const { data: curriculumInfo } = await getCurriculumInfo();
        this.curriculumInfo = curriculumInfo;
    },
    computed: {
        todayDate() {
            return (
                this.selectedDate ||
                (() => {
                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0');
                    const day = String(today.getDate()).padStart(2, '0');
                    const week = ['일', '월', '화', '수', '목', '금', '토'][today.getDay()];
                    return `${year}.${month}.${day}(${week})`;
                })()
            );
        },
        reContents: function () {
            return (this.curriculumInfo?.contents || '').split('\n');
        },
        reContents2: function () {
            if (this.selectedSeminar) {
                return this.selectedSeminar.guide.split('\n');
            }
            return [];
        },
        selectedCount() {
            return this.selectedDateCount;
        },
    },
};
</script>
